// table info
export const tableHeaders = ["Code", "Name", "Rate"];

export const columnNames = ["code", "name", "rate"];

export const searchColumn = "";
